import { render, staticRenderFns } from "./DeletedPhotoList.vue?vue&type=template&id=afb96d22&scoped=true&"
import script from "./DeletedPhotoList.vue?vue&type=script&lang=js&"
export * from "./DeletedPhotoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb96d22",
  null
  
)

export default component.exports